const Container = ({ children }: { children: React.ReactNode }) => {
  return <div className=''>{children}</div>;
};

export default Container;
